import React, { useState } from "react";
import { Upload, Form, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import useRequest from "../hooks/useRequest";

import { ShowToast, Severty} from "../helper/toast";

const SingleImageUpload = ({
  label = "Upload image",
  rules,
  onChange,
  refreshData,
  dataImage,
  removeApi,
  editApi,
}) => {
  const { request } = useRequest();
  const [file, setFile] = useState(
    dataImage?.image
      ? [
          {
            uid: dataImage._id,
            name: dataImage._id,
            status: "done",
            url: dataImage.image,
          },
        ]
      : []
  );
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
    "image/gif",
  ];

  const validateFile = (file) => {
    if (!FileType.includes(file.type)) {
      message.error("File format is not correct");
      return false;
    } else {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        message.error(`Image must be smaller than 5 MB!`);
        return false;
      }
    }
    return true;
  };
  const handleImgChange = async (event) => {
    const { file } = event;
    if (!validateFile(file)) {
      return;
    }
    if (dataImage && editApi) {
      
      
      const formData = new FormData();
      formData.append("image", file);
     await request({
        url: `${editApi}/${dataImage._id}`,
        method: "post",
        data: formData,
        onSuccess: (data) => {
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          if (error.response.data.status === 400) {
            ShowToast(error.response.data.message, Severty.WARNING);
          } else {
            ShowToast(error.response.data.message, Severty.ERROR);
          }
        },
      });
      if (refreshData) {
      refreshData();
      }
    }
    setFile([file]);
    onChange(file);
    
  };
  const handleRemove = async () => {
    if (removeApi && dataImage) {
     await request({
        url: `${removeApi}/${dataImage._id}`,
        method: "get",
        onSuccess: (data) => {
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          if (error.response.data.status === 400) {
            ShowToast(error.response.data.message, Severty.WARNING);
          } else {
            ShowToast(error.response.data.message, Severty.ERROR);
          }
        },
      });
      if (refreshData) {
        refreshData();
      }
    }
    setFile([]);
   
  };

  return (
    <Form.Item label={label} name="image" rules={rules}>
      <Upload
        listType="picture"
        beforeUpload={validateFile}
        customRequest={handleImgChange}
        onRemove={handleRemove}
        showUploadList={{ showRemoveIcon: true, showPreviewIcon: true }}
        fileList={file}
      >
        {file && file.length > 0 ? null : (
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        )}
      </Upload>
    </Form.Item>
  );
};

export default SingleImageUpload;
